import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material//dialog';

@Component({
  selector: 'app-quick-assist',
  templateUrl: './quick-assist.component.html',
  styleUrls: ['./quick-assist.component.css']
})
export class QuickAssistComponent implements OnInit {

  typeActionMap: TypeActionMapEntry[] = [{
    "icon": "person",
    "color": "rgb(35, 48, 142)",
    "title": "Ansprechpartner anlegen",
    "subTitle": "Einen neuen Ansprechpartner erzeugen",
    "action": WistaAMSAssistCallbacks.CreateContactperson
  }, {
    "icon": "euro_symbol",
    "color": "#147ac7",
    "title": "Angebot anlegen",
    "subTitle": "Ein neues Angebot erzeugen",
    "action": WistaAMSAssistCallbacks.CreateOffer
  }, {
    "icon": "domain",
    "color": "rgb(35, 119, 138)",
    "title": "Kunden anlegen",
    "subTitle": "Einen neuen Kunden erzeugen",
    "action": WistaAMSAssistCallbacks.CreateCustomer
  }, {
    "icon": "flash_on",
    "color": "#e2960b",
    "title": "Ticket anlegen",
    "subTitle": "Einen neuen Incident/ein neues Ticket erzeugen",
    "action": WistaAMSAssistCallbacks.CreateIncidentTransaction
  }, {
    "icon": "add_location_alt",
    "color": "#ab8549",
    "title": "Standort anlegen",
    "subTitle": "Einen neuen Standort erzeugen",
    "action": WistaAMSAssistCallbacks.CreateLocation
  }, {
    "icon": "assessment",
    "color": "#994c76",
    "title": "Vertrag anlegen",
    "subTitle": "Einen neuen Vertrag erzeugen",
    "action": WistaAMSAssistCallbacks.CreateContract
  }, {
    "icon": "assessment",
    "color": "#78a56c",
    "title": "Vorgang anlegen",
    "subTitle": "Einen neuen Auftrag erzeugen",
    "action": WistaAMSAssistCallbacks.CreateIssue
  }];

  constructor(
    private _ref: MatDialogRef<QuickAssistComponent>
  ) { }

  close() {
    this._ref.close(null);
  }

  do(action: number){
    this._ref.close(action);
  }

  ngOnInit(): void {
  }

}

export const WistaAMSAssistCallbacks = {
  "CreateIncidentTransaction": 1,
  "CreateCustomer": 2,
  "CreateContactperson": 3,
  "CreateIssue": 4,
  "CreateContract": 5,
  "CreateLocation": 6,
  'CreateOffer': 7
}

class TypeActionMapEntry {
  icon: string;
  color: string;
  title: string;
  subTitle: string;
  action: number;
}
